<template>
	<div
		:class="[
			'container__cardmapinfoitem',
			{ 'container__cardmapinfoitem--active': mapInfo.isActived },
		]"
		@click="clickCardItem(mapInfo)"
	>
		<div class="container__cardmapinfoitem__info">
			<label class="container__cardmapinfoitem__info__title">
				{{ mapInfo.titulo }}
			</label>
			<div class="container__cardmapinfoitem__info__information">
				<div
					v-for="(info, index) in mapInfo.infos"
					:key="index"
				>
					<label class="container__cardmapinfoitem__info__information__field">
						{{ info.label }}
					</label>
					<label>{{ info.value }}</label>
				</div>
			</div>
			<a
				v-show="isDashboardGeral && mapInfo.existeProcessamento"
				class="container__cardmapinfoitem__info__data"
				@click="setFazendaId(mapInfo.id)"
				>{{ $t('verDadosFazenda') }} →</a
			>
			<p v-show="isDashboardGeral && !mapInfo.existeProcessamento">
				{{ $t('fazendaSemProcessamento') }}
			</p>
		</div>
		<div id="hiddenElement" />
		<div
			v-if="mapInfo.infoGeo.poligono && !isLoadingPolygons"
			class="container__cardmapinfoitem__map"
		>
			<PoligonoSvg :info-geo="mapInfo.infoGeo" />
		</div>
		<div
			v-else-if="isLoadingPolygons"
			class="container__cardmapinfoitem__map"
		>
			<Loading />
		</div>
		<div
			v-else
			class="container__cardmapinfoitem__map"
		>
			<p>{{ $t('polygonNotImported') }}</p>
		</div>
	</div>
</template>

<script>
import Loading from '../../../../components/Loading/Loading'
import PoligonoSvg from '../../../../components/PoligonoSvg/PoligonoSvg'

export default {
	components: { Loading, PoligonoSvg },
	props: {
		/**
		 * Informacoes do card
		 */
		mapInfo: Object,
		/**
		 * Variavel para controlar se esta em dashboard geral ou nao
		 */
		isDashboardGeral: Boolean,
		/**
		 * Funcao para setar o id da fazenda do componente pai
		 */
		setFazendaId: Function,
	},
	computed: {
		/**
		 * Estado que verifica se esta bucando dados do backend para o componente CardMap
		 */
		isLoadingPolygons() {
			return this.$store.state.moduleDashboardCardInfo.isLoadingPolygons
		},
	},
	methods: {
		/**
		 * Clique no card item
		 */
		clickCardItem(mapInfo) {
			mapInfo.isActived = !mapInfo.isActived
			// if (!this.isDashboardGeral && !mapInfo.isActived) {
			//   this.$store.commit(
			//     "moduleDashboardCardInfo/removeMarkersPlantioByIdEstratoInventarioFlorestal",
			//     mapInfo.inventarioEstratoFlorestalId
			//   );
			// } else if (!this.isDashboardGeral && mapInfo.isActived) {
			//   this.$store.dispatch(
			//     "moduleDashboardCardInfo/apiMarkersPlantio",
			//     mapInfo.inventarioEstratoFlorestalId
			//   );
			// }

			this.$store.dispatch('moduleDashboardCardInfo/getPlantiosEstratosSelecionados')
		},
	},
}
</script>

<style>
.container__cardmapinfoitem {
	padding: 0.3rem 1rem;
	margin: 0.5rem;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 0.75rem;
	border-radius: 3px;
	cursor: pointer;
	border: 1px solid rgba(0, 0, 0, 0.2);
	transition: border 0.1s ease-in-out;
}

.container__cardmapinfoitem--active {
	border: 2px solid rgb(var(--color-default));
}

.container__cardmapinfoitem__info {
	width: 15rem;
	height: auto;
}

.container__cardmapinfoitem__info p:last-child {
	color: rgb(var(--color-rgb-gray));
	cursor: no-drop;
	margin-bottom: 0.35rem;
}

.container__cardmapinfoitem__info__title {
	font-weight: 700;
	color: rgb(var(--color-primary));
	cursor: inherit;
}

.container__cardmapinfoitem__info__information {
	line-height: 1.1rem;
}

.container__cardmapinfoitem__info__information label {
	cursor: inherit;
}

.container__cardmapinfoitem__info__information__field {
	font-weight: 700;
}

.container__cardmapinfoitem__info__data {
	cursor: pointer;
	text-decoration: underline;
}

.container__cardmapinfoitem__map {
	height: 6rem;
	width: 6rem;
	animation: anima__img 0.3s ease-in-out forwards;
	display: flex;
	justify-content: space-around;
	/* align-items: center;
  text-align: center; */
}

@keyframes anima__img {
	0% {
		transform: scale(0);
	}

	100% {
		transform: scale(1);
	}
}
</style>
